import { Route, Routes } from 'react-router-dom'
import GradingPage from './Page'
import { useSession } from 'components/Providers';
import NoAccess from 'components/NoAccess';

export default function Grading() {
  const { permissions } = useSession();
  if (!permissions['setting.grading'] && !permissions['setting.academic']) return <NoAccess />

  return (
    <Routes>
      <Route path="/" element={<GradingPage />} />
      <Route path="/:type/:id" element={<GradingPage />} />
    </Routes>
  )
}
